export default __webpack_public_path__ + "static/media/step-three.98e8c62f.png";